import axios from "axios";
import React from "react";

import { translate } from "react-i18next";

class Carousel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      drug: undefined
    };
  }

  render() {
    return (
      <div id="landing-page-carousel" className="carousel slide">
        <div className="carousel-inner" role="listbox">
          <div className="item active">
            <img
              className="first-slide"
              src={process.env.PUBLIC_URL + "/assets/images/recipes-banner.jpg"} 
              alt="First slide"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(Carousel);
